/******
 * This file was generated by a Rake task.
 * Do not modify this file manually.
 * Add changes to the `ProcurementFilterTeam.ts` file.
 ******/
// oxlint-disable-next-line no-unused-vars
import dayjs, { Dayjs } from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
dayjs.extend(timezone);

import { ProcurementFilterTeam } from "./ProcurementFilterTeam";

import { ProcurementFilter } from "./ProcurementFilter";
import { Team } from "./Team";

export type procurementRole = "receiving_team" | "vendor";

export const procurementRoleValues = { receiving_team: 0, vendor: 1 };

export abstract class ProcurementFilterTeamModel {
    id: number;
    createdAt: Dayjs;
    procurementFilterId: number;
    procurementRole: procurementRole;
    teamId: number;
    updatedAt: Dayjs;
    procurementFilter: ProcurementFilter | null | undefined;
    team: Team | null | undefined;
    _destroy: boolean | undefined;

    /* eslint-disable max-statements */
    constructor(
        id: number,
        createdAt: Dayjs,
        procurementFilterId: number,
        procurementRole: procurementRole,
        teamId: number,
        updatedAt: Dayjs,
        procurementFilter: ProcurementFilter | null | undefined,
        team: Team | null | undefined
    ) {
        this.id = id;
        this.createdAt = createdAt;
        this.procurementFilterId = procurementFilterId;
        this.procurementRole = procurementRole;
        this.teamId = teamId;
        this.updatedAt = updatedAt;
        this.procurementFilter = procurementFilter;
        this.team = team;
    }
    /* eslint-enable max-statements */

    // oxlint-disable-next-line complexity
    static fromApiObject(json: any, timezone: string): ProcurementFilterTeam {
        const newObject = new ProcurementFilterTeam(
            json["id"],
            dayjs(json["created_at"]).tz(timezone),
            json["procurement_filter_id"],
            json["procurement_role"],
            json["team_id"],
            dayjs(json["updated_at"]).tz(timezone),
            json["procurement_filter"] == null
                ? json["procurement_filter"]
                : ProcurementFilter.fromApiObject(json["procurement_filter"], timezone),
            json["team"] == null ? json["team"] : Team.fromApiObject(json["team"], timezone)
        );

        return newObject;
    }

    // oxlint-disable-next-line complexity
    toApiObject(): any {
        return {
            id: this.id,
            created_at: this.createdAt,
            procurement_filter_id: this.procurementFilterId,
            procurement_role: this.procurementRole,
            team_id: this.teamId,
            updated_at: this.updatedAt,
            _destroy: this._destroy,
        };
    }

    // NOTE: This could potentially cause infinite loops if the object graph is
    // circular.
    inAlternateTimezone(timezone: string): ProcurementFilterTeam {
        const clone = Object.create(this) as ProcurementFilterTeam;

        for (const key of Object.keys(this)) {
            if (this[key] instanceof dayjs) {
                // @ts-expect-error: Typescript thinks that this is not a dayjs object even though it is checked on the line before
                clone[key] = this[key].tz(timezone);
            } else if (Array.isArray(this[key])) {
                clone[key] = this[key].map((item) =>
                    item.inAlternateTimezone ? item.inAlternateTimezone(timezone) : item
                );
            } else if (this[key] && this[key].inAlternateTimezone) {
                clone[key] = this[key].inAlternateTimezone(timezone);
            }
        }

        return clone;
    }
}
